import { p as t } from "../../plugin-CBs7of0e.js";
import e from "../colors/index.js";
const s = t(({ addBase: o }) => {
  o({
    html: {
      fontSize: "16px",
      color: e.neutral.inverse,
      fontSynthesis: "none",
      textRendering: "optimizeLegibility",
      "-webkit-font-smoothing": "antialiased",
      "-moz-osx-font-smoothing": "grayscale"
    }
  });
});
export {
  s as default
};
